export default "__VITE_ASSET__C$1eqzF2__"